/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RelationsScopeFilter } from './relationsScopeFilter';


export interface RelationsIncludeFilterItems { 
    relation?: RelationsIncludeFilterItems.RelationEnum;
    scope?: RelationsScopeFilter;
}
export namespace RelationsIncludeFilterItems {
    export type RelationEnum = 'user' | 'relatedUser' | 'relationType';
    export const RelationEnum = {
        User: 'user' as RelationEnum,
        RelatedUser: 'relatedUser' as RelationEnum,
        RelationType: 'relationType' as RelationEnum
    };
}


